export default "__VITE_ASSET__BDjVDRGW__"